const SettingsConfig = {
  theme: 'light',
};

export default SettingsConfig;
